import { processListingStatus } from '@util/listings';
import { ConstellationUtils } from '@engelvoelkersamericas/eva-listings-sdk/lib/client'

export interface MediaGalleryData {
  imagesArr: string[];
  floorPlanArr: string[];
  videoData: string | null;
  virtualTourData: string | null;
  listingStatus: string | null;
  streetViewData: { lat: number; lng: number } | null;
  listingId: string;
  zipCode: string;
  cooperativeAgencyStatus: string | null;
}

const mapMediaGalleryData = (listingData): MediaGalleryData => {
  const updatedListingData = {
    ...listingData,
    Enhancement: [listingData?.evaMetadata],
  };
  //
  //
  // Photos and Floor Plans
  //
  let imagesArr: string[] = [];
  let floorPlanArr: string[] = [];

  const photos = ConstellationUtils.getPhotos(updatedListingData);
  const floorPlans = ConstellationUtils.getFloorPlans(updatedListingData);

  if (photos) {
    imagesArr = photos.map((photo) => photo.MediaURL || '').filter((i) => Boolean(i));
  }
  if (floorPlans) {
    floorPlans.map((floorPlan) => {
      if (floorPlan.MediaURL) {
        floorPlanArr.push(`${floorPlan.MediaURL}?d=l`);
      }
    });
  }

  //
  //
  // Video Data
  // Unbranded => Branded => General Video
  //
  const videoMediaList = ConstellationUtils.getVideos(updatedListingData);
  let videoData: string | null = null;

  // check if listingData.evaMetadata for any media.MediaCategory === 'Unbranded Video'
  let categoryVideos = videoMediaList?.filter((obj) => obj?.MediaCategory === 'Unbranded Video');

  if (categoryVideos?.length) {
    videoData = categoryVideos?.[0]?.MediaURL || null;
  }
  // check if listingData.evaMetadata for any media.MediaCategory === 'Branded Video'
  if (!videoData) {
    categoryVideos = videoMediaList?.filter((obj) => obj.MediaCategory === 'Branded Video');
    if (categoryVideos?.length) {
      videoData = categoryVideos?.[0]?.MediaURL || null;
    }
  }

  // if videoData is still falsey, then check for category "Video"
  if (!videoData) {
    categoryVideos = videoMediaList?.filter((obj) => obj.MediaCategory === 'Video');
    if (categoryVideos?.length) {
      videoData = categoryVideos?.[0]?.MediaURL || null;
    }
  }

  // Video can sometimes come in through VirtualTourURLUnbranded
  if (!videoData && listingData.VirtualTourURLUnbranded) {
    if (
      listingData.VirtualTourURLUnbranded.includes('youtu') ||
      listingData.VirtualTourURLUnbranded.includes('vimeo')
    ) {
      videoData = listingData.VirtualTourURLUnbranded;
    }
  }

  //
  //
  // Virtual Tour Data
  //
  const virtualTourList = ConstellationUtils.getVirtualTours(updatedListingData);

  // check if media.MediaCategory === 'Unbranded Virtual Tour', add it to virtualTourData
  let virtualTourData = virtualTourList?.filter(
    (obj) =>
      obj.MediaCategory === 'Unbranded Virtual Tour' &&
      !obj?.MediaURL?.includes('youtu') &&
      !obj?.MediaURL?.includes('vimeo'),
  )[0]?.MediaURL || null;
  // if virtualTourData is null, check if media.MediaCategory === 'Branded Virtual Tour', add it to virtualTourData
  if (!virtualTourData) {
    virtualTourData = virtualTourList?.filter(
      (obj) =>
        obj.MediaCategory === 'Branded Virtual Tour' &&
        !obj?.MediaURL?.includes('youtu') &&
        !obj?.MediaURL?.includes('vimeo'),
    )[0]?.MediaURL || null;
  }
  // if virtualTourData is null, check if media.MediaCategory === 'Virtual Tour', add it to virtualTourData
  if (!virtualTourData) {
    virtualTourData = virtualTourList?.filter(
      (obj) =>
        obj.MediaCategory === 'Virtual Tour' &&
        !obj?.MediaURL?.includes('youtu') &&
        !obj?.MediaURL?.includes('vimeo'),
    )[0]?.MediaURL || null;
  }
  //
  //
  // Street View Data
  //
  const tmpCoordinates = ConstellationUtils.getCoordinates(updatedListingData);
  let streetViewData = tmpCoordinates?.Lon && tmpCoordinates?.Lon
      ? {
          lat: tmpCoordinates.Lat,
          lng: tmpCoordinates.Lon,
        }
      : null;

  let openHouse: any[] = [];
  if (listingData?.OriginatingSystemName === 'EVAMLS') {
    openHouse = listingData.evaMetadata?.OpenHouse ?? [];
  } else if (listingData?.evaMetadata?.OpenHouse?.length > 0) {
    if (listingData?.OpenHouse?.length > 0) {
      openHouse = [...listingData.evaMetadata?.OpenHouse, ...listingData?.OpenHouse];
    } else {
      openHouse = listingData.evaMetadata?.OpenHouse;
    }
  } else {
    openHouse = listingData.OpenHouse ?? [];
  }

  const processedStatus = processListingStatus(
    openHouse,
    listingData.StandardStatus,
    listingData.PropertyType,
  );
  return {
    imagesArr: imagesArr,
    floorPlanArr: floorPlanArr,
    videoData: videoData,
    virtualTourData: virtualTourData,
    listingStatus: processedStatus,
    streetViewData: streetViewData,
    listingId: listingData.ListingId,
    zipCode: listingData.PostalCode,
    cooperativeAgencyStatus: listingData?.cooperativeAgencyStatus,
  };
};

export default mapMediaGalleryData;
